import { ReactComponent as BusIcon } from "../../../../assets/icons/Bus.svg";
import { ReactComponent as GroutUserIcon } from "../../../../assets/icons/g-user.svg";
import { ReactComponent as GraphIcon } from "../../../../assets/icons/graph.svg";
import { ReactComponent as UserCircleIcon } from "../../../../assets/icons/user-c.svg";
import Phone01 from "../../../../assets/images/ph01.png";
import Phone02 from "../../../../assets/images/ph02.png";

const Platform: React.FC = () => {
  return (
    <div className="h-full p-4 sm:p-6 py-12 sm:py-16 lg:py-28 text-hColor">
      <div className="max-w-[95vw] sm:max-w-[90vw] xl:max-w-[87vw] mx-auto">
        {/* Hero Section */}
        <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between space-y-8 xl:space-y-0 xl:space-x-8">
          {/* Left Content */}
          <div className="w-full xl:w-[618px]">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl xl:text-[36px] leading-tight">
              One platform built for all stakeholder
            </h1>
            <p className="mt-4 sm:mt-6 lg:mt-8 text-sm sm:text-base lg:text-lg xl:text-[18px] text-pColor max-w-full xl:w-[553px]">
              Manage, drive, or rent out vehicles effortlessly with Fleet
              Pro—your all-in-one platform with dedicated apps for
              organizations, drivers, and vehicle owners.
            </p>
          </div>

          {/* Right Content - Stakeholder Cards */}
          <div className="flex flex-col space-y-4 sm:space-y-6 lg:space-y-8 w-full xl:w-[870px]">
            {/* First Row */}
            <div className="flex flex-col lg:flex-row lg:items-center space-y-4 lg:space-y-0 lg:space-x-4 xl:space-x-8">
              <div className="flex items-center space-x-3 sm:space-x-4 w-full lg:flex-1 xl:w-[424px]">
                <div className="w-12 h-12 sm:w-16 sm:h-16 lg:w-[82px] lg:h-[82px] bg-[#EDF2DFB2] rounded-lg flex items-center justify-center flex-shrink-0">
                  <BusIcon className="w-6 h-6 sm:w-8 sm:h-8 lg:w-auto lg:h-auto" />
                </div>
                <div className="flex-1">
                  <h2 className="text-base sm:text-lg lg:text-xl xl:text-[21px] leading-tight">
                    Logistics & Delivery Companies
                  </h2>
                  <p className="text-xs sm:text-sm lg:text-base xl:text-[16px] text-pColor mt-1">
                    Track vehicles, optimize routes, and manage your fleet
                    operations.
                  </p>
                </div>
              </div>

              <div className="flex items-center space-x-3 sm:space-x-4 w-full lg:flex-1 xl:w-[404px]">
                <div className="w-12 h-12 sm:w-16 sm:h-16 lg:w-[82px] lg:h-[82px] bg-[#EDF2DFB2] rounded-lg flex items-center justify-center flex-shrink-0">
                  <UserCircleIcon className="w-6 h-6 sm:w-8 sm:h-8 lg:w-auto lg:h-auto" />
                </div>
                <div className="flex-1">
                  <h2 className="text-base sm:text-lg lg:text-xl xl:text-[21px]">
                    Vehicle owners
                  </h2>
                  <p className="text-xs sm:text-sm lg:text-base xl:text-[16px] text-pColor mt-1">
                    Monitor vehicle usage, earnings, and maintenance anywhere
                  </p>
                </div>
              </div>
            </div>

            {/* Second Row */}
            <div className="flex flex-col lg:flex-row lg:items-center space-y-4 lg:space-y-0 lg:space-x-4 xl:space-x-8">
              <div className="flex items-center space-x-3 sm:space-x-4 w-full lg:flex-1 xl:w-[424px]">
                <div className="w-12 h-12 sm:w-16 sm:h-16 lg:w-[82px] lg:h-[82px] bg-[#EDF2DFB2] rounded-lg flex items-center justify-center flex-shrink-0">
                  <GroutUserIcon className="w-6 h-6 sm:w-8 sm:h-8 lg:w-auto lg:h-auto" />
                </div>
                <div className="flex-1">
                  <h2 className="text-base sm:text-lg lg:text-xl xl:text-[21px]">
                    Drivers
                  </h2>
                  <p className="text-xs sm:text-sm lg:text-base xl:text-[16px] text-pColor mt-1">
                    Start trips, track performance, and monitor earnings
                  </p>
                </div>
              </div>

              <div className="flex items-center space-x-3 sm:space-x-4 w-full lg:flex-1 xl:w-[424px]">
                <div className="w-12 h-12 sm:w-16 sm:h-16 lg:w-[82px] lg:h-[82px] bg-[#EDF2DFB2] rounded-lg flex items-center justify-center flex-shrink-0">
                  <GraphIcon className="w-6 h-6 sm:w-8 sm:h-8 lg:w-auto lg:h-auto" />
                </div>
                <div className="flex-1">
                  <h2 className="text-base sm:text-lg lg:text-xl xl:text-[21px]">
                    Financial institutions
                  </h2>
                  <p className="text-xs sm:text-sm lg:text-base xl:text-[16px] text-pColor mt-1">
                    Start trips, track performance, and monitor earnings
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section - CTA and Mobile Apps */}
        <div className="flex flex-col xl:flex-row xl:items-start xl:justify-between space-y-8 xl:space-y-0 xl:space-x-8 mt-8 sm:mt-12 lg:mt-24 xl:mt-36">
          {/* CTA Card */}
          <div className="w-full sm:max-w-[500px] xl:w-[528px] h-auto xl:h-[619px] text-[#FFFFFF] bg-[#90AA36] rounded-[12px] p-6 sm:p-8 lg:p-10 xl:p-12 flex flex-col justify-between">
            <div>
              <h2 className="text-xl sm:text-2xl lg:text-3xl xl:text-[36px] leading-tight">
                Let's drive your fleet forward
              </h2>
              <p className="text-sm sm:text-base lg:text-lg xl:text-[21px] mt-4 sm:mt-6 lg:mt-8 xl:mt-10">
                Have questions or need assistance? We're here to help! Reach out
                to us for inquiries, support, or partnership opportunities.
              </p>
            </div>

            <div className="mt-6 sm:mt-8 xl:mt-60">
              <button className="border border-[#FFFFFF] px-4 py-2 sm:px-6 sm:py-3 xl:px-4 xl:py-2 rounded-[12px] text-sm sm:text-base hover:bg-white hover:text-[#90AA36] transition-colors duration-200">
                Contact us
              </button>
            </div>
          </div>

          {/* Mobile Apps Section */}
          <div className="flex flex-col sm:flex-row xl:flex-row gap-6 sm:gap-8 xl:gap-8 w-full xl:w-auto">
            {/* Company App */}
            <div className="w-full sm:w-1/2 xl:w-[400px] 2xl:w-[528px] flex flex-col items-center space-y-3 sm:space-y-4 lg:space-y-6 xl:space-y-8">
              <div className="w-full h-[300px] sm:h-[400px] lg:h-[619px] overflow-hidden rounded-lg">
                <img
                  src={Phone01}
                  alt="Mobile app for Companies"
                  className="w-full h-full"
                />
              </div>
              <h3 className="text-base sm:text-lg lg:text-xl xl:text-[24px] text-center">
                Mobile app for Companies
              </h3>
            </div>

            {/* Driver App */}
            <div className="w-full sm:w-1/2 xl:w-[400px] 2xl:w-[528px] flex flex-col items-center space-y-3 sm:space-y-4 lg:space-y-6 xl:space-y-8">
              <div className="w-full h-[300px] sm:h-[400px] lg:h-[619px] overflow-hidden rounded-lg">
                <img
                  src={Phone02}
                  alt="Mobile app for Drivers"
                  className="w-full h-full"
                />
              </div>
              <h3 className="text-base sm:text-lg lg:text-xl xl:text-[24px] text-center">
                Mobile App for Drivers
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Platform;
